import React from 'react';
import { Typography } from '@mui/material';
import Data from '../../Data/PersonalInfo.json';

// @desc vision and future expectations
const Summary = () => {
  return <Typography variant='summary'>{Data.summary} </Typography>;
};

export default Summary;
